import {useState} from 'react'
import {KTSVG} from '../../../../../../../_metronic/helpers'
import { formatVerificationChecksKyb, thousandMarker } from '../../../../../../../utils/streamlineSpecificHelpers';

type Props = {
  data: any
  setType: Function
  loading: boolean
}

const VerificationListCounters: React.FC<Props> = ({data,setType,loading}) => {
  const [activeType, setActiveType] = useState('business_ltd')

  const handleType = (type:string) => {
    setActiveType(type)
    setType(type)
  }

  return (
    <div className='row gy-5 gx-xl-10 mb-10'>
      {!loading && 
        <>
          {data?.map((check:any, index:number) => {
            const i:any = formatVerificationChecksKyb(check?._type)
            return (
              <div className="col-sm-6 col-xl-3" key={index} onClick={(e) => handleType(check?._type)}>
                <div className={`card pointer border-1 border border-gray-500 ${(check?._type === activeType) ? 'border-gray-600':'border-active'}`}>
                    <div className="card-body px-5 py-4">         
                        <div className="row">
                          <div className="col-10">
                            <div className='mb-2 text-gray-700 fs-7 text-uppercase'>{i?.title}</div>
                            <div className="">
                                <span className="fw-semibold fs-2x text-gray-800 lh-1 ls-n2">
                                  {thousandMarker(check?.success_count)}
                                  <span className='px-2 fs-5 ls-1'>
                                    /{thousandMarker(check?.total_count)}
                                  </span>
                                  {check?.success_count > 0 && 
                                  <span className={`px-5 ls-1 ${(check?._type === activeType) && 'text-success'}`}>
                                    <span className='fs-6 ls-n0'><span className='fs-8'>{check?.currency}</span>{thousandMarker((check?.usage_amount))}</span></span>
                                  }
                                </span>
                                <div className="m-0 mt-1">
                                  <span className="fw-semibold fs-7 text-gray-500">
                                    Failed: {check?.failed_count} — Success Rate: {check?.success_rate}%
                                  </span>
                                </div>
                            </div>
                          </div>
                          <div className="col-2">
                            <div className="mt-0">
                              <KTSVG path={`/assets/media/icons/duotune/${i?.icon}.svg`} className={`svg-icon-2x ${(check?._type === activeType) ? 'svg-icon-success':'svg-icon-dark'} `} />
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
              </div>
            )
          })}
        </>
      }
      {loading && 
        <div className='col-sm-12'>
          <div className='card pointer border-2'>
            <div className='card-body row timeline d-flex justify-content-center text-center flex-column min-h-200px'>
                <span>
                    <span className='spinner-border spinner-border-md align-middle text-gray-600'></span>
                </span>
                <span className='text-gray-600 fs-8 mt-3'>Just a moment while we retrieve the verification types...</span>
            </div>
          </div>
        </div>
      }
    </div>
  )
}

export {VerificationListCounters}